import { css, mediaQueries } from '@eti/styles';
import { useDateFormat, useSearch, useTranslation } from '@eti/providers';
import FormattedSearchTripDate from '../../../common/components/FormattedSearchTripDate';
import { MULTI_STOP } from '../../../constants/tripTypesConstants';

const wrapperStyles = css`
  font-size: 0.75rem;
  text-align: center;

  @media ${mediaQueries.large.up} {
    font-size: 1rem;
  }
`;

const originAndDestinationStyles = css`
  display: flex;
  font-size: 1.125rem;
  font-weight: 700;
  justify-content: center;
  margin-bottom: 0.375rem;

  @media ${mediaQueries.large.up} {
    font-size: 1.375rem;
  }
`;

const separatorStyles = css`
  display: inline-block;
  padding: 0 0.35rem;
`;

const SearchTransitionTripDetails = () => {
  const { t } = useTranslation();
  const { dayYear } = useDateFormat();
  const { currentSearchData } = useSearch();
  const { date, destination, origin, travelers, tripType } = currentSearchData ?? {};

  return (
    <div className={wrapperStyles} data-testid="metaEntry-tripDetails">
      <h2 className={originAndDestinationStyles}>
        {tripType === MULTI_STOP ? (
          t('SearchTransition.MultipleDestinations')
        ) : (
          <>
            <span>{origin?.city}</span>
            <span className={separatorStyles}>–</span>
            <span>{destination?.city}</span>
          </>
        )}
      </h2>
      {tripType === MULTI_STOP ? (
        t('SearchTransition.MultipleDates')
      ) : (
        <>
          <div>{date?.return ? t('Air.Search.Return') : t('Air.Search.Oneway')}</div>
          {date?.departure && (
            <FormattedSearchTripDate
              dateFormat={dayYear}
              endDate={date.return}
              startDate={date.departure}
            />
          )}
        </>
      )}
      <div>{travelers?.summary}</div>
    </div>
  );
};

export default SearchTransitionTripDetails;
